import styled from "styled-components";

interface TooltipContainerProps {
  bgColor?: string;
  color?: string;
}

export const Container = styled.div<TooltipContainerProps>`
  position: relative;
  span {
    /* width: 160px; */
    background: ${({ bgColor }) => (bgColor ? bgColor : "var(--primary)")};
    white-space: nowrap;
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    opacity: 0;
    transition: opacity 0.4s;
    visibility: hidden;
    position: absolute;
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translateX(-50%);
    color: ${({ color }) =>
      color ? `${color} !important` : "#312e38 !important"};
    &::before {
      content: "";
      border-style: solid;
      border-color: ${({ bgColor }) =>
        bgColor ? `${bgColor} transparent` : "var(--primary) transparent"};
      border-width: 6px 6px 0 6px;
      top: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  &:hover span {
    visibility: visible;
    opacity: 1;
  }
`;
